import makeStyles from '@mui/styles/makeStyles'

const useStyles = makeStyles(theme => ({
  avatarHolder: {
    display: 'flex',
    justifyContent: 'center',
    marginBottom: '16px'
  },

  findTitle: {
    marginBottom: '16px',
    fontSize: theme.size.base,
    color: '#1F1F1F'
  },

  inputArea: {
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    borderBottom: '1px solid #C6C6C6',
    cursor: 'text',

    '&:focus-within': {
      borderBottomColor: 'black'
    }
  },

  input: {
    marginBottom: '8px',
    border: 'none',
    width: '100%',
    fontSize: theme.size.base,
    color: '#1F1F1F',
    outline: 'none',
    background: 'transparent',
    textOverflow: 'ellipsis',

    '&::placholder': {
      color: '#8F8F8F'
    }
  },

  resultsContainer: {
    zIndex: 3,
    position: 'absolute',
    display: 'flex',
    flexDirection: 'column',
    border: '1px solid #F0F0F0',
    borderRadius: '7px',
    boxSizing: 'border-box',
    boxShadow: '0px 20px 30px rgba(0, 0, 0, 0.16)',
    padding: '16px',
    background: 'white'
  },

  results: {
    display: 'flex',
    flexDirection: 'column',
    maxHeight: '208px',
    overflow: 'hidden auto',

    '&::-webkit-scrollbar': {
      width: 8
    },

    '&::-webkit-scrollbar-track': {
      backgroundColor: '#E5E5E5'
    },

    '&::-webkit-scrollbar-thumb': {
      backgroundColor: theme.palette.primary.main,
      borderRadius: 0
    }
  },

  result: {
    borderRadius: '8px',
    padding: '12px 0',

    '&:hover': {
      background: '#F5F6F8'
    }
  }
}))

export default useStyles
